import React, {useCallback, useContext} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import {Icons} from '@pb/kit-component-icon';
import IconButton from '@pb/kit-component-icon-button';


import {copyButton} from './copy-button.module.styl';

import type {IconSize} from '@pb/kit-component-icon';

type Props = {
    copiedText: string,
    entityName: string,
    iconSize?: IconSize,
    disabled?: boolean,
};
export const CopyButton: React.FC<Props> = ({copiedText, entityName, iconSize, disabled}) => {
    const {setSuccessMessage} = useContext(MessageContext);

    const onCopy = useCallback(() => {
        navigator.clipboard.writeText(copiedText).then(() => {
            setSuccessMessage(`${entityName} copied to your clipboard`);
        });
    }, [copiedText, entityName, setSuccessMessage]);

    return (
        <IconButton
            className={copyButton}
            flat={true}
            iconProps={{size: iconSize, type: Icons.COPY}}
            onClick={onCopy}
            disabled={disabled}
        />
    );
};
